
























import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Selector from '@ui/Inputs/Selector'
import TagBar from '@ui/TagBar'

settings =
  name: 'CampaignSelector'

  vue:
    props: ['campaigns', 'selectedKeys', 'theme', 'actions']
    components: { Selector, TagBar }

    computed:
      campaignOptions: ->
        @campaigns.map((campaign) ->
          {
            id: campaign.id,
            key: campaign.id,
            value: campaign.name,
            sortBy: "#{campaign.name} #{campaign.owner?.email} #{campaign.brand_info?.name}",
            brand: campaign.brand_info?.name,
            name: campaign.name,
            email: campaign.owner?.email,
            deactivated: campaign.owner?.deactivated,
            emails_silenced: campaign.owner?.emails_silenced,
            trusted: campaign.owner?.trusted,
          }
        )

    methods:
      hasAlert: (option) ->
        return {value: true, tooltip: "Deactivated" } if option.deactivated
        return {value: true, tooltip: "Silenced" } if option.emails_silenced
        return {value: true, tooltip: "Untrusted" } unless option.trusted
        return {value:false, tooltip: ""}

      selectorOptions: ->
        {
          searchBoxPlaceholder: 'Search by name',
          selectOptionsTitle: false,
        }

export default VueOptions.vue settings
